(function () {
  'use strict';

  function initializeContactHubs() {
    document.querySelectorAll('[data-taili-contact]').forEach((root) => {
      if (root.dataset.tailiContactReady === 'true') return;
      root.dataset.tailiContactReady = 'true';

      const routes = Array.from(root.querySelectorAll('[data-taili-route]'));
      const topic = root.querySelector('[data-taili-topic]');
      const formHeading = root.querySelector('[data-taili-form-heading]');
      const orderHint = root.querySelector('[data-taili-order-hint]');
      const form = root.querySelector('.tc-form');
      const submit = root.querySelector('[data-taili-submit]');
      const submitLabel = root.querySelector('[data-taili-submit-label]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!topic) return;

      function syncRouteState() {
        routes.forEach((route) => {
          if (!route.hasAttribute('aria-pressed')) return;
          route.setAttribute('aria-pressed', String(route.dataset.topic === topic.value));
        });

        if (orderHint) {
          const needsOrder = topic.value === 'Order support' || topic.value === 'Returns & refunds';
          orderHint.dataset.relevant = String(needsOrder);
        }
      }

      routes.forEach((route) => {
        if (route.tagName !== 'BUTTON') return;

        route.addEventListener('click', () => {
          const matchingOption = Array.from(topic.options).find((option) => option.value === route.dataset.topic);
          if (!matchingOption) return;

          topic.value = matchingOption.value;
          topic.dispatchEvent(new Event('change', { bubbles: true }));

          if (formHeading) {
            formHeading.focus({ preventScroll: true });
            formHeading.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          } else {
            topic.focus({ preventScroll: true });
            topic.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          }
        });
      });

      topic.addEventListener('change', syncRouteState);
      syncRouteState();

      if (form && submit && submitLabel) {
        const originalLabel = submitLabel.textContent;

        form.addEventListener('submit', () => {
          if (!form.checkValidity()) return;
          submit.setAttribute('aria-busy', 'true');
          submitLabel.textContent = submit.dataset.loadingLabel || 'Sending…';
        });

        window.addEventListener('pageshow', () => {
          submit.removeAttribute('aria-busy');
          submitLabel.textContent = originalLabel;
        });
      }

      const message = root.querySelector('[data-taili-form-message]');
      if (message) message.focus();
    });
  }

  initializeContactHubs();
  document.addEventListener('shopify:section:load', initializeContactHubs);
})();
